import React from "react";
import CartContent from "./CartContent";

const CartPage = () => {
  return (
    <div>
      <CartContent />
    </div>
  );
};

export default CartPage;
